import { lazy, Suspense } from "react";
import Navbar from "./components/Navbar/Navbar";
import AppRoutes from "./routes/AppRoutes";
import ScrollToTop from "./components/ScrollToTop";
import RouteSeo from "./components/RouteSeo/RouteSeo";

const Footer = lazy(() => import("./components/Footer/Footer"));
const ScrollButtons = lazy(() => import("./components/ScrollButton/ScrollButtons"));

function App() {
  return (
    <>
      <RouteSeo />
      <ScrollToTop />
      <Navbar />
      <AppRoutes />
      <Suspense fallback={null}>
        <Footer />
        <ScrollButtons />
      </Suspense>
    </>
  );
}

export default App;

